import { patientBffApi } from '@/modules/baseApi';
import { unwrapApiErrorDetails } from '@ianesthesie-kit/services';
import { TerraService } from './terra.service';

export const terraApi = patientBffApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    terraIsIntegrated: builder.query<boolean, void>({
      providesTags: ['TerraIntegration'],
      keepUnusedDataFor: Infinity,
      queryFn: () =>
        TerraService.getInstance()
          .isIntegrated()
          .then((data) => ({
            data
          }))
          .catch((err) => ({
            error: unwrapApiErrorDetails(err) || err
          }))
    }),

    terraIsEligible: builder.query<boolean, void>({
      providesTags: ['TerraIntegration'],
      keepUnusedDataFor: Infinity,
      queryFn: () =>
        TerraService.getInstance()
          .isEligibleToConnect()
          .then((data) => ({
            data
          }))
          .catch((err) => ({
            error: unwrapApiErrorDetails(err) || err
          }))
    }),

    terraUnsubscribe: builder.mutation<void, void>({
      invalidatesTags: ['TerraIntegration'],
      queryFn: () =>
        TerraService.getInstance()
          .unregister()
          .then((data) => ({
            data
          }))
          .catch((err) => ({
            error: unwrapApiErrorDetails(err) || err
          }))
    })
  })
});

export const {
  useTerraIsIntegratedQuery,
  useTerraIsEligibleQuery,
  useTerraUnsubscribeMutation
} = terraApi;
